import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { convertDateToDateForComponent, convertDateToDateTimeForComponent } from "presentation/utils/timeUtil";
import { memo } from "react";

const ChargeDetailHeaderPanel = () => {

    // const VSL_SUMMARY_CONSTANT = ChargeConstant.VesselSummary;
    const CHARGE_CONSTANT = ChargeConstant.Charge;
    const [chargeHeaderState] = useChargeHeaderMaintenanceTracked();
    const [chargeDetailState] = useChargeDetailTracked();
    const currentChargeHeader = chargeDetailState?.currentChargeHeader ? chargeDetailState?.currentChargeHeader : chargeHeaderState?.currentChargeHeader;

    return <div className="headerInfo">
        <div className="fiveColumns">
            {
                currentChargeHeader?.opsDate ?
                    (
                        <div className={"item"}>
                            <div className={"label"}>
                                {ChargeConstant.Charge.OPS_DATE}
                            </div>
                            <div className={"value"}>
                                {convertDateToDateForComponent(currentChargeHeader?.opsDate)}
                            </div>
                        </div>
                    )
                    :
                    (
                        <>
                            {<>
                                <div className={"item"}>
                                    <div className={"label"}>
                                        {`${CHARGE_CONSTANT.CO_VSL_VOY}`}
                                    </div>
                                    <div className={"value"}>
                                        {`${currentChargeHeader?.consortiumCode ?? ""}/
                                        ${currentChargeHeader?.vesselCode ?? ""}/
                                    ${currentChargeHeader?.voyageCode ?? ""}`
                                        }
                                    </div>
                                </div>
                                <div className={"item"}>
                                    <div className={"label"}>
                                        {ChargeConstant.Charge.ETD}
                                    </div>
                                    <div className={"value"}>
                                        {convertDateToDateTimeForComponent(currentChargeHeader?.etd)}
                                    </div>
                                </div></>}
                        </>)
            }

        </div>
    </div>
}

export default memo(ChargeDetailHeaderPanel);